import { type MouseEventHandler, useMemo } from 'react';

import { ChartFallback } from '../Chart/ChartFallback';
import { ChartNotSupported } from '../Chart/ChartNotSupported';
import type { ResolvedData } from '../DataResolver/resolve-items';
import type { MetricValues } from '../PageConfigProvider/types/metric';
import type { DataProviderChildren, DataProviderSet } from './types';
import {
  type TableDataSetType,
  tableToDataSet,
} from './utils/table-to-data-set';

export const ResolvedDataProvider = ({
  resolved: { data: table, status, error },
  dataType,
  metric,
  children,
  onClick,
}: {
  resolved: ResolvedData;
  dataType: TableDataSetType;
  metric: MetricValues | undefined;
  children: DataProviderChildren<DataProviderSet>;
  onClick?: MouseEventHandler<HTMLDivElement>;
}) => {
  const data = useMemo(
    () =>
      table && metric ? tableToDataSet(table, dataType, metric) : undefined,
    [table, dataType, metric]
  );
  if (table && !data) return <ChartNotSupported onClick={onClick} />;

  return (
    <ChartFallback status={status} onClick={onClick}>
      {children({ data, status, error })}
    </ChartFallback>
  );
};
